import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Profile.css"; // make sure this file exists
import { message } from "antd";

const Profile = () => {
  const [activeTab, setActiveTab] = useState("basic");

  const [profileData, setProfileData] = useState({
    fullName: "",
    instagramUsername: "",
    status: "",
    about: "",
    gender: "",
    dob: "",
    maritalStatus: "",
    interestedIn: [],
    languages: [],
    religion: "",
    pets: false,
smoke: false,
  drink: false,  // ⭐ NEW FIELDS
  email: "",
  mobile: "",
  address: "",
  aadhar: "",highSchool: "",  // ✅ new
  diploma: "",     // ✅ new
  graduation: "",   // ✅ new
   // 🏠 Places
  livesIn: "",
  from: "",
  currentLocation: "",
    donateBlood: false,
  helpPeople: false,
  volunteer: false,
    blogger: false,
  entrepreneur: false,
  traveller: false,
weather: {
  temperature: "",
  humidity: "",
condition: ""
,
  city: "",
},
 });
// ⭐ Input field for comma-separated languages text
const [languagesInput, setLanguagesInput] = useState("");

  const toggleBoolean = (field) => {
    setProfileData((prevData) => ({
      ...prevData,
      [field]: !prevData[field],
    }));
  };

  // Fetch existing user data
  useEffect(() => {
    const fetchProfile = async () => {
      try {
const res = await axios.get(`/api/userauth/profile`, {
headers: { Authorization: `Bearer ${localStorage.getItem("hm_token")}` },
        });
       if (res.data && res.data.data) {
  const data = res.data.data;
  setProfileData({
    fullName: data.fullName || "",
    instagramUsername: data.instagramUsername || "",
    status: data.status || "",
    about: data.about || "",
    gender: data.gender || "",
    dob: data.dob || "",
    maritalStatus: data.maritalStatus || "",
    interestedIn: data.interestedIn || [],
    languages: data.languages || [],
    religion: data.religion || "",
    pets: data.pets || false,
smoke: data.smoke || false,
drink: data.drink || false,
email: data.email || "",
  mobile: data.mobile || "",
  address: data.address || "",
  aadhar: data.aadhar || "",
   highSchool: data.highSchool || "",  // ✅ new
  diploma: data.diploma || "",        // ✅ new
  graduation: data.graduation || "" ,  // ✅ new
   // 🏠 Places
  livesIn: data.livesIn || "",
  from: data.from || "",
  currentLocation: data.currentLocation || "",
   donateBlood: data.donateBlood || false,
  helpPeople: data.helpPeople || false,
  volunteer: data.volunteer || false,
    blogger: data.blogger || false,
  entrepreneur: data.entrepreneur || false,
  traveller: data.traveller || false,
weather: data.weather || {},

  });
}
setLanguagesInput((res.data.data.languages || []).join(", "));

      } catch (error) {
        message.error("Failed to load profile data");
      }
    };
    fetchProfile();
  }, []);
useEffect(() => {
  console.log("Current Location:", profileData.currentLocation);
}, [profileData.currentLocation]);
  // Save updated profile data
  const handleSave = async () => {
    try {
  await axios.put(
  `/api/userauth/update-profile`,
  {
    ...profileData,


    // ⭐ Convert comma-separated text → array
    languages: languagesInput
      .split(",")
      .map(l => l.trim())
      .filter(l => l !== "")
  },
  { headers: { Authorization: `Bearer ${localStorage.getItem("hm_token")}` } }
);


message.success("Profile updated successfully!");

// 🔥 Fetch updated data again so weather appears instantly
const res = await axios.get(`/api/userauth/profile`, {
  headers: { Authorization: `Bearer ${localStorage.getItem("hm_token")}` }
});

setProfileData(res.data.data);

    } catch (error) {
      message.error("Failed to update profile");
    }
  };
// 🔐 Change Password Modal
const [showPasswordModal, setShowPasswordModal] = useState(false);

const [passwordData, setPasswordData] = useState({
 currentPassword: "",
newPassword: "",
confirmPassword: "",

});
const handleChangePassword = async () => {
  try {
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      return message.error("New passwords do not match!");
    }

    await axios.put(`/api/userauth/change-password`,

      passwordData,
      { headers: { Authorization: `Bearer ${localStorage.getItem("hm_token")}` } }
    );

    message.success("Password updated successfully!");
    setShowPasswordModal(false);
  } catch (err) {
    message.error(err.response?.data?.message || "Failed to change password");
  }
};
const isGoogleUser = profileData.authProvider === "google";

  return (
    <div className="profile-page">
      {/* Tabs */}
      <div className="profile-tabs">
        <button
          className={activeTab === "basic" ? "active" : ""}
          onClick={() => setActiveTab("basic")}
        >
          Basic Info
        </button>
        <button
          className={activeTab === "contact" ? "active" : ""}
          onClick={() => setActiveTab("contact")}
        >
          Contact Info
        </button>
        <button
          className={activeTab === "education" ? "active" : ""}
          onClick={() => setActiveTab("education")}
        >
          Education
        </button>
        <button
          className={activeTab === "places" ? "active" : ""}
          onClick={() => setActiveTab("places")}
        >
          Places
        </button>
        <button
  className={activeTab === "services" ? "active" : ""}
  onClick={() => setActiveTab("services")}
>
  Services
</button>
<button
  className={activeTab === "public" ? "active" : ""}
  onClick={() => setActiveTab("public")}
>
  Public Tags
</button>

      </div>

      {/* Tab content */}
      <div className="profile-content">
        {activeTab === "basic" && (
          <>
            <h2>Basic Info</h2>
            <div className="form-grid">
              {/* Full Name */}
              <div>
                <label>Full Name</label>
                <input
                  type="text"
                  value={profileData.fullName}
                  onChange={(e) =>
                    setProfileData({ ...profileData, fullName: e.target.value })
                  }
                />
              </div>

              {/* Instagram */}
              <div>
                <label>Instagram Username</label>
                <input
                  type="text"
                  value={profileData.instagramUsername}
                  onChange={(e) =>
                    setProfileData({
                      ...profileData,
                      instagramUsername: e.target.value,
                    })
                  }
                />
              </div>

              {/* Status */}
              <div>
                <label>Status</label>
                <input
                  type="text"
                  value={profileData.status}
                  onChange={(e) =>
                    setProfileData({ ...profileData, status: e.target.value })
                  }
                />
              </div>

              {/* About */}
              <div>
                <label>About</label>
                <textarea
                  value={profileData.about}
                  onChange={(e) =>
                    setProfileData({ ...profileData, about: e.target.value })
                  }
                />
              </div>

              {/* Gender */}
              <div>
                <label>Gender</label>
                <select
                  value={profileData.gender}
                  onChange={(e) =>
                    setProfileData({ ...profileData, gender: e.target.value })
                  }
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              {/* Date of Birth */}
              <div>
                <label>Date of Birth</label>
                <input
                  type="date"
                  value={profileData.dob?.split("T")[0] || ""}
                  onChange={(e) =>
                    setProfileData({ ...profileData, dob: e.target.value })
                  }
                />
              </div>

              {/* Religion */}
             {/* Religion */}
<div>
  <label>Religion</label>
  <select
    value={profileData.religion}
    onChange={(e) =>
      setProfileData({ ...profileData, religion: e.target.value })
    }
  >
    <option value="">Select Religion</option>
    <option value="Hinduism">Hinduism</option>
    <option value="Buddhism">Buddhism</option>
    <option value="Christianity">Christianity</option>
    <option value="Islam">Islam</option>
    <option value="Judaism">Judaism</option>
    <option value="Sikhism">Sikhism</option>
    <option value="Jainism">Jainism</option>
  </select>
</div>
              {/* Marital Status */}
              <div>
                <label>Marital Status</label>
                <select
                  value={profileData.maritalStatus}
                  onChange={(e) =>
                    setProfileData({
                      ...profileData,
                      maritalStatus: e.target.value,
                    })
                  }
                >
                  <option value="">Select</option>
                  <option value="Single">Single</option>
                  <option value="Married">Married</option>
                  <option value="Divorced">Divorced</option>
                </select>
              </div>
             <div>
  <label>Interested In</label>
  <select
    value={profileData.interestedIn[0] || ""}
    onChange={(e) =>
      setProfileData({
        ...profileData,
        interestedIn: [e.target.value], // <-- always array
      })
    }
  >
    <option value="">Select</option>
    <option value="Men">Men</option>
    <option value="Women">Women</option>
    <option value="Both">Both</option>
  </select>
</div>
              {/* Languages */}
              <div>
                <label>Languages</label>
               <input
  type="text"
  value={languagesInput}
  placeholder="e.g. English, Hindi, Portuguese"
  onChange={(e) => setLanguagesInput(e.target.value)}
/>

              </div>


              {/* Pets Toggle */}
              <div className="toggle-group">
                <label>Have Pets</label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={profileData.pets}
                    onChange={() => toggleBoolean("pets")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              {/* Smoke/Drink Toggle */}
            <div className="toggle-group">
  <label>Smoke</label>
  <label className="switch">
    <input
      type="checkbox"
      checked={profileData.smoke}
      onChange={() => toggleBoolean("smoke")}
    />
    <span className="slider round"></span>
  </label>
</div>
<div className="toggle-group">
  <label>Drink</label>
  <label className="switch">
    <input
      type="checkbox"
      checked={profileData.drink}
      onChange={() => toggleBoolean("drink")}
    />
    <span className="slider round"></span>
  </label>
</div>
            </div>

            <button className="save-btn" onClick={handleSave}>
              Save Changes
            </button>
          </>
        )}

       {activeTab === "contact" && (
  <>
    <h2>Contact Info</h2>
    <div className="form-grid">

      {/* Email - read only */}
      <div>
        <label>Email</label>
        <input type="text" value={profileData.email} disabled />
      </div>

      {/* Mobile */}
      <div>
        <label>Mobile Number</label>
        <input
          type="text"
          value={profileData.mobile || ""}
          onChange={(e) =>
            setProfileData({ ...profileData, mobile: e.target.value })
          }
        />
      </div>

      {/* Address */}
      <div>
        <label>Address</label>
        <input
          type="text"
          value={profileData.address || ""}
          onChange={(e) =>
            setProfileData({ ...profileData, address: e.target.value })
          }
        />
      </div>

      {/* Aadhar */}
      <div>
        <label>Aadhar Number</label>
        <input
          type="text"
          value={profileData.aadhar || ""}
          onChange={(e) =>
            setProfileData({ ...profileData, aadhar: e.target.value })
          }
        />
      </div>

      {/* Masked password */}
   <div style={{ display: "flex", flexDirection: "column" }}>
  <label>Password</label>

  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
    <input type="password" value="********" disabled />

    <button
      disabled={isGoogleUser}
      style={{
        padding: "6px 12px",
        fontSize: "12px",
        cursor: isGoogleUser ? "not-allowed" : "pointer",
        opacity: isGoogleUser ? 0.5 : 1,
        borderRadius: "6px",
        border: "1px solid #ccc",
        background: "#fff",
      }}
      onClick={() => !isGoogleUser && setShowPasswordModal(true)}
    >
      Change
    </button>
  </div>
</div>

    </div>

    <button className="save-btn" onClick={handleSave}>
      Save Contact Info
    </button>
  </>
)}
{/* ✅ Add Education tab content here */}
  {activeTab === "education" && (
    <>
      <h2>Education</h2>
      <div className="form-grid">
        <div>
          <label>High School</label>
          <input
            type="text"
            value={profileData.highSchool || ""}
            onChange={(e) =>
              setProfileData({ ...profileData, highSchool: e.target.value })
            }
          />
        </div>
        <div>
          <label>Diploma</label>
          <input
            type="text"
            value={profileData.diploma || ""}
            onChange={(e) =>
              setProfileData({ ...profileData, diploma: e.target.value })
            }
          />
        </div>
        <div>
          <label>Graduation</label>
          <input
            type="text"
            value={profileData.graduation || ""}
            onChange={(e) =>
              setProfileData({ ...profileData, graduation: e.target.value })
            }
          />
        </div>
      </div>
      <button className="save-btn" onClick={handleSave}>
        Save Education
      </button>
    </>
  )}
{activeTab === "places" && (
  <>
    <h2>Places</h2>
    <div className="form-grid">
      <div>
        <label>Lives In</label>
        <input
          type="text"
          value={profileData.livesIn}
          onChange={(e) =>
            setProfileData({ ...profileData, livesIn: e.target.value })
          }
        />
      </div>

      <div>
        <label>From</label>
        <input
          type="text"
          value={profileData.from}
          onChange={(e) =>
            setProfileData({ ...profileData, from: e.target.value })
          }
        />
      </div>

      <div>
        <label>Current Location</label>
        <input
          type="text"
          value={profileData.currentLocation}
          onChange={(e) =>
            setProfileData({ ...profileData, currentLocation: e.target.value })
          }
        />
      </div>
    </div>

    <button className="save-btn" onClick={handleSave}>
      Save Places
    </button>
        {/* 🌤 Weather Box - Display Only If Exists */}
    {profileData.weather && profileData.weather.city && (
      <div className="weather-box" style={{
        marginTop: "20px",
        padding: "15px",
        borderRadius: "10px",
        background: "#f5f5f5",
      }}>
        <h3>🌦 Current Weather in {profileData.weather.city}</h3>
        <p><strong>Temperature:</strong> {profileData.weather.temperature} °C</p>
        <p><strong>Humidity:</strong> {profileData.weather.humidity} %</p>
    <p><strong>Condition:</strong> {profileData.weather.condition}</p> 
      </div>
    )}
  </>
)}
{activeTab === "services" && (
  <>
    <h2>Services</h2>
    <div className="form-grid">
      <div className="toggle-group">
        <label>Want to Donate Blood?</label>
        <label className="switch">
          <input
            type="checkbox"
            checked={profileData.donateBlood}
            onChange={() => toggleBoolean("donateBlood")}
          />
          <span className="slider round"></span>
        </label>
      </div>

      <div className="toggle-group">
        <label>Want to Help People?</label>
        <label className="switch">
          <input
            type="checkbox"
            checked={profileData.helpPeople}
            onChange={() => toggleBoolean("helpPeople")}
          />
          <span className="slider round"></span>
        </label>
      </div>

      <div className="toggle-group">
        <label>Want to Volunteer for Community Service?</label>
        <label className="switch">
          <input
            type="checkbox"
            checked={profileData.volunteer}
            onChange={() => toggleBoolean("volunteer")}
          />
          <span className="slider round"></span>
        </label>
      </div>
    </div>

    <button className="save-btn" onClick={handleSave}>
      Save Services
    </button>
  </>
)}
{activeTab === "public" && (
  <>
    <h2>Public Tags</h2>
    <div className="form-grid">

      <div className="toggle-group">
        <label>Blogger</label>
        <label className="switch">
          <input
            type="checkbox"
            checked={profileData.blogger}
            onChange={() => toggleBoolean("blogger")}
          />
          <span className="slider round"></span>
        </label>
      </div>

      <div className="toggle-group">
        <label>Entrepreneur</label>
        <label className="switch">
          <input
            type="checkbox"
            checked={profileData.entrepreneur}
            onChange={() => toggleBoolean("entrepreneur")}
          />
          <span className="slider round"></span>
        </label>
      </div>

      <div className="toggle-group">
        <label>Traveller</label>
        <label className="switch">
          <input
            type="checkbox"
            checked={profileData.traveller}
            onChange={() => toggleBoolean("traveller")}
          />
          <span className="slider round"></span>
        </label>
      </div>
    </div>
    <button className="save-btn" onClick={handleSave}>
      Save Public Tags
    </button>
  </>
)}
{/* 🔐 Change Password Modal */}
{showPasswordModal && (
  <div className="profile-modal-overlay">
    <div className="profile-modal-box">
      <h3>Change Password</h3>

      <label>Old Password</label>
      <input
        type="password"
        value={passwordData.currentPassword}
        onChange={(e) =>
          setPasswordData({
            ...passwordData,
            currentPassword: e.target.value,
          })
        }
      />

      <label>New Password</label>
      <input
        type="password"
        value={passwordData.newPassword}
        onChange={(e) =>
          setPasswordData({ ...passwordData, newPassword: e.target.value })
        }
      />

      <label>Confirm New Password</label>
      <input
        type="password"
        value={passwordData.confirmPassword}
        onChange={(e) =>
          setPasswordData({ ...passwordData, confirmPassword: e.target.value })
        }
      />

      <div className="profile-modal-actions">
        <button onClick={handleChangePassword}>Update</button>
        <button onClick={() => setShowPasswordModal(false)}>Cancel</button>
      </div>
    </div>
  </div>
)}

      </div>
    </div>
  );
};

export default Profile;
